module.exports = __webpack_public_path__ + "img/e41.b714c2a5.png";